import { render, staticRenderFns } from "./weeklyView.vue?vue&type=template&id=1601a5ed&scoped=true"
import script from "./weeklyView.vue?vue&type=script&lang=js"
export * from "./weeklyView.vue?vue&type=script&lang=js"
import style0 from "./weeklyView.vue?vue&type=style&index=0&id=1601a5ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1601a5ed",
  null
  
)

export default component.exports